module.exports = __webpack_public_path__ + "static/media/2.5bdc4430.jpg";